<script setup lang="ts">
import NamaLogo from "@/assets/logos/NamaLogo.vue";
import ExceedLogo from "@/assets/logos/ExceedLogo.vue";
import AutoPracticeLogo from "@/assets/logos/AutoPracticeLogo.vue";
import SoftVisionLogo from "@/assets/logos/SoftVisionLogo.vue";
import CapitalLogo from "@/assets/logos/CapitalLogo.vue";
import RaCoreLogo from "@/assets/logos/RaCoreLogo.vue";
import {onMounted, ref} from "vue";
import DefaultApplicationInfo from "@/utils/common/DefaultApplicationInfo.ts";

const currentBranding = ref()
const props = defineProps({
  hasTitle: {
    type: Boolean,
    default: false
  },
  isSpinner: {
    type: Boolean,
    default: false
  },
  isDarkLight: {
    type: Boolean,
    default: false,
  }
})

onMounted(() => {
  currentBranding.value = (window as any).branding || "nama";
})

const brandingComponents = {
  nama: NamaLogo,
  exceed: ExceedLogo,
  softvision: SoftVisionLogo,
  autopractice: AutoPracticeLogo,
  capital: CapitalLogo,
  racore: RaCoreLogo
}
</script>
<template>
  <div v-if="isDarkLight" class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"
       :title="hasTitle?DefaultApplicationInfo.applicationVersion():undefined">
    <component :is="brandingComponents[currentBranding]" :isSpinner="isSpinner" v-bind="$attrs" class="tw-max-h-48"/>
  </div>
  <component v-else :is="brandingComponents[currentBranding]" :isSpinner="true"
             :class="{'capital-branding':currentBranding=='capital' && !isSpinner}"/>
</template>
